import { formatAnswerValue } from "./formAnswerDisplay";
export function getResponseSortValue(row, key, fieldMap) {
    if (key === "submitted_at") {
        const time = new Date(String(row.submitted_at || "").replace(" ", "T")).getTime();
        return Number.isNaN(time) ? 0 : time;
    }
    if (key === "user.fullname") {
        return String(row.user?.fullname || "").toLowerCase();
    }
    if (key === "user.role") {
        const roles = row.user?.roles || [];
        const label = roles.length
            ? (roles[0].displayName || roles[0].display_name || "")
            : "";
        return String(label).toLowerCase();
    }
    const field = fieldMap[key];
    if (!field)
        return "";
    const raw = row.answers ? row.answers[key] : undefined;
    if (raw === null || raw === undefined || raw === "") {
        return field.type === "rating" || field.type === "number" ? -1 : "";
    }
    if (field.type === "rating" || field.type === "number") {
        const num = Number(raw);
        return Number.isNaN(num) ? -1 : num;
    }
    if (field.type === "date") {
        const time = new Date(String(raw).replace(" ", "T")).getTime();
        return Number.isNaN(time) ? 0 : time;
    }
    return String(formatAnswerValue(field, raw)).toLowerCase();
}
export function compareResponseRows(a, b, key, direction, fieldMap) {
    const av = getResponseSortValue(a, key, fieldMap);
    const bv = getResponseSortValue(b, key, fieldMap);
    let cmp = 0;
    if (typeof av === "number" && typeof bv === "number") {
        cmp = av - bv;
    }
    else {
        cmp = String(av).localeCompare(String(bv), "vi");
    }
    return direction === "asc" ? cmp : -cmp;
}
export function defaultSortDirectionForKey(key) {
    return key === "submitted_at" ? "desc" : "asc";
}
